export default __webpack_public_path__ + "static/media/b3.69e86706.JPG";